// Entry of the web app: self-hosted fonts, the design tokens, theme, service worker, query client and router.
// Every string goes through the message catalogue (B20); the shell lives in src/app (docs/CONTRACTS.md section 16).
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@fontsource-variable/bricolage-grotesque/opsz.css'
import '@fontsource-variable/onest/index.css'
import '@fontsource/martian-mono/400.css'
import '@fontsource/martian-mono/500.css'
import './styles/index.css'
import { App } from './app/App.tsx'
import { createAppRouter } from './app/router.tsx'
import { clientBuild } from './lib/build.ts'
import { startServiceWorker } from './lib/pwa.ts'
import { createQueryClient } from './lib/query.ts'
import { applyTheme } from './lib/theme.ts'

applyTheme()
document.documentElement.dataset.build = clientBuild // which release this page runs (support, and the end-to-end tests)
startServiceWorker()

const queryClient = createQueryClient()
const router = createAppRouter(queryClient)

const root = document.getElementById('root')
if (!root) throw new Error('missing #root')

createRoot(root).render(
  <StrictMode>
    <App queryClient={queryClient} router={router} />
  </StrictMode>,
)
